export default __webpack_public_path__ + "static/runservice4-b537dfb54b1a3eaceca78743e77be115.png";